import { render, staticRenderFns } from "./userArchives.vue?vue&type=template&id=eccd61ca&scoped=true&"
import script from "./userArchives.vue?vue&type=script&lang=js&"
export * from "./userArchives.vue?vue&type=script&lang=js&"
import style0 from "./userArchives.vue?vue&type=style&index=0&id=eccd61ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccd61ca",
  null
  
)

export default component.exports